import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Field, reduxForm, SubmissionError } from 'redux-form'
import { parse } from 'qs'

import { localize } from 'helpers/translator'
import { GoogleIcon, OfficeIcon, CleverIcon, ClasslinkIcon } from 'components/icon'
import generalActions from 'redux/actions/generalActions'
import signupActions from 'redux/actions/signupActions'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import { MainButton } from 'components/button'
import TextLink from 'components/text_link/text_link'
import CheckboxInputForm from 'components/input/checkbox/checkbox_input_form'

import styles from './signup_sso.scss'

const validate = values => {
	const errors = {}
	if (!values.terms) {
		errors.terms = 'signUp_form_mustAcceptTerms'
	}
	return errors
}

class SsoSignup extends PureComponent {

	constructor(props) {
		super(props)
		this.getFieldStatus = this.getFieldStatus.bind(this)
	}

	componentDidMount() {
		const params = parse(location.search.substr(1))
		if (params.ps === '1') {
			this.props.actions.openMessage(
				{
					alertTitle: 'global_areYouStudent_question',
					alertMessage: 'signUp_studentAlertMessage',
					buttons: [
						{
							buttonName: 'global_joinALesson',
							callback: () => {
								window.location.href = '/student'
							},
						},
						{
							buttonName: 'global_signUp',
						},
					],
				},
				'alert')
		}
	}

	getFieldStatus(field) {
		if (field.touched && !(field.active)) {
			if (field.invalid) {
				return 'error'
			} else {
				return 'success'
			}
		} else {
			return ''
		}
	}

	renderSubtitle = () => {
		switch (this.props.match.path) {
			case '/signup/google':
				return (
					<h2 styleName='header-subtitle'>
						<span styleName='header-subtitle-icon'><GoogleIcon /></span>
						{`${localize('signup_with')} `}
						<strong styleName='header-subtitle-strong'>
							{localize('signup_with_google')}
						</strong>
					</h2>
				)
			case '/signup/office':
				return (
					<h2 styleName='header-subtitle'>
						<span styleName='header-subtitle-icon'><OfficeIcon /></span>
						{`${localize('signup_with')} `}
						<strong styleName='header-subtitle-strong'>
							{localize('signup_with_office')}
						</strong>
					</h2>
				)
			case '/signup/clever':
				return (
					<h2 styleName='header-subtitle'>
						<span styleName='header-subtitle-icon'><CleverIcon /></span>
						{`${localize('signup_with')} `}
						<strong styleName='header-subtitle-strong'>
							{localize('signup_with_clever')}
						</strong>
					</h2>
				)
			case '/signup/classlink':
				return (
					<h2 styleName='header-subtitle'>
						<span styleName='header-subtitle-icon'><ClasslinkIcon /></span>
						{`${localize('signup_with')} `}
						<strong styleName='header-subtitle-strong'>
							{localize('signup_with_classlink')}
						</strong>
					</h2>
				)
			default: // TODO: reevaluate this default's usefulness checking if /sso redirect is being used anywhere on Nearpod
				return (
					<h2 styleName='header-subtitle'>
						<span styleName='header-subtitle-icon'><GoogleIcon /></span>
						{`${localize('signup_with')} `}
						<strong styleName='header-subtitle-strong'>
							{localize('signup_with_google')}
						</strong>
					</h2>
				)
		}
	}

	handleSignupSubmit = values => {
		const params = parse(location.search.substr(1))
		values.sk = params.sk
		return new Promise((resolve, reject) => {
			this.props.actions.sendSsoSignupForm(values, resolve, reject)
		}).catch(function(err) {
			throw new SubmissionError({...err})
		})
	}

	render() {

		const {
			error,
			handleSubmit,
			submitting } = this.props

		return (
			<article styleName='wrapper'>
				<header styleName='header'>
					<h1 styleName='header-title'>{localize('sign_up_teachers_title')}</h1>
					{this.renderSubtitle()}
				</header>
				<form styleName='form' onSubmit={handleSubmit(this.handleSignupSubmit)}>
					<div styleName='form-disclaimer'>
						<div styleName='form-disclaimer-checkbox'>
							<Field
								name="terms"
								component={CheckboxInputForm}
								type="checkbox"
								props={{
									fieldStatus: this.getFieldStatus,
								}}
							/>
						</div>
						<label styleName='form-disclaimer-text'>
							{`${localize('signUp_terms_start')} `}
							<TextLink
								styleName='form-disclaimer-link'
								href='https://nearpod.com/terms-conditions'
								target='_blank'
							>
								{localize('signUp_terms_link')}
							</TextLink>
							{` ${localize('signUp_terms_end')}`}
						</label>
						{ this.props.submitFailed &&
							!this.props.valid &&
							<span styleName='form-disclaimer-error'>
								{localize('signUp_form_mustAcceptTerms2')}
							</span>
						}
					</div>
					<div styleName='form-button'>
						<MainButton
							type='submit'
							pill={true}
							disabled={submitting}
						>
							{localize('global_signUp')}
						</MainButton>
					</div>
					{ error && <div styleName='form-error'>{error}</div> }
				</form>
				<p styleName='text'>
					{`${localize('global_areYouStudent_question')} `}
					<Link styleName='text-link' to='/student'>{localize('global_joinALesson')}.</Link>
				</p>
			</article>
		)
	}
}

SsoSignup.propTypes = {
	match: PropTypes.shape({
		path: PropTypes.string,
	}).isRequired,
	actions: PropTypes.object,
	fields: PropTypes.array.isRequired,
	handleSubmit: PropTypes.func.isRequired,
	error: PropTypes.string,
	submitting: PropTypes.bool.isRequired,
	submitFailed: PropTypes.bool.isRequired,
	valid: PropTypes.bool.isRequired,
}

const DecoratedForm = reduxForm({
	form: 'SsoForm',
	fields: ['terms'],
	validate,
})(CSSModules(SsoSignup, styles, {allowMultiple: true}))

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		openMessage: generalActions.openMessage,
		sendSsoSignupForm: signupActions.sendSsoSignupForm,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(DecoratedForm)
